import { createContext } from 'react';

import {
  useGetCurrentChild,
  useGetParentChildren,
  useParentForgotPassword,
  useParentLogin,
  useParentLogout,
  useParentResetPassword,
  useRemoveCurrentChild,
  useSetCurrentChild,
} from '../api/parent/dashboard/parentDashboardQueries.js';
import { useGetParent, useUpdateParent } from '../api/parent/parentQueries.js';

export const ParentContext = createContext();

export const ParentProvider = ({ children }) => {
  const { data: currentChild } = useGetCurrentChild();
  const { mutate: setCurrentChild } = useSetCurrentChild();
  const { mutate: removeCurrentChild } = useRemoveCurrentChild();
  const {
    data: parent,
    isLoading: isParentLoading,
    refetch: refetchParent,
  } = useGetParent();

  const {
    data: parentChildren,
    isLoading: isChildrenLoading,
    refetch: refetchChildren,
  } = useGetParentChildren(parent && parent.parentId);

  const { mutate: parentLogout, isPending: isParentLoggingOut } =
    useParentLogout();

  const {
    mutate: parentLogin,
    isPending: parentLoginLoading,
    error: parentLoginError,
  } = useParentLogin();

  const {
    mutate: parentForgotPassword,
    isPending: parentForgotPasswordLoading,
    error: parentForgotPasswordError,
    isSuccess: parentForgotPasswordSuccess,
  } = useParentForgotPassword();

  const {
    mutate: parentResetPassword,
    isPending: parentResetPasswordLoading,
    isSuccess: parentResetPasswordSuccess,
  } = useParentResetPassword();

  const { mutate: updateParent, isPending: updateParentPending } =
    useUpdateParent();

  return (
    <ParentContext.Provider
      value={{
        parent,
        parentChildren,
        currentChild,
        isChildrenLoading,
        isParentLoading,
        parentLoginLoading,
        parentLoginError,
        parentForgotPasswordLoading,
        parentForgotPasswordError,
        parentForgotPasswordSuccess,
        parentResetPasswordLoading,
        parentResetPasswordSuccess,
        isParentLoggingOut,
        updateParentPending,
        updateParent,
        parentLogout,
        parentResetPassword,
        parentForgotPassword,
        parentLogin,
        refetchParent,
        setCurrentChild,
        removeCurrentChild,
        refetchChildren,
      }}
    >
      {children}
    </ParentContext.Provider>
  );
};
